const SKILL_COLORS: Record<string, string> = {
  Chef: 'bg-orange-500/10 text-orange-400 border-orange-500/20',
  CDP: 'bg-orange-500/10 text-orange-400 border-orange-500/20',
  'Sous Chef': 'bg-orange-500/10 text-orange-400 border-orange-500/20',
  Kitchen: 'bg-orange-500/10 text-orange-400 border-orange-500/20',
  'Pot Wash': 'bg-orange-500/10 text-orange-400 border-orange-500/20',
  'FOH Restaurant': 'bg-primary/10 text-primary border-primary/20',
  'FOH Bar': 'bg-primary/10 text-primary border-primary/20',
  Events: 'bg-purple-500/10 text-purple-400 border-purple-500/20',
  Management: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
  Agency: 'bg-muted text-muted-foreground border-border',
  Temp: 'bg-muted text-muted-foreground border-border',
  Trainer: 'bg-green-500/10 text-green-400 border-green-500/20',
  Supervisor: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
};

export default function SkillBadges({ skills }: { skills: string[] }) {
  if (!skills || skills.length === 0) {
    return <p className="text-xs text-muted-foreground italic">No skills assigned yet — your manager will set these up.</p>;
  }
  return (
    <div className="flex flex-wrap gap-1.5">
      {skills.map(skill => (
        <span key={skill} className={`text-xs px-2.5 py-0.5 border rounded-sm font-medium ${SKILL_COLORS[skill] || 'bg-muted text-muted-foreground border-border'}`}>
          {skill}
        </span>
      ))}
    </div>
  );
}
